<div class="u-height-100" fxLayout="column">
  <div fxFlex="100%" class="u-overflow-auto u-showScrollBar u-padding-24">
    <form [formGroup]="privateSegmentForm">
      <app-group-segment-input-form
        [formControl]="segmentInputControl"
        [description]="privateSegment?.description"
        [title]="privateSegment?.title"
        class="u-display-block"
      ></app-group-segment-input-form>
      <p
        class="u-marginBottom-8 text-subtitle-2"
        i18n="@@groupPrivateSegmentsDrawer.privacyLabel"
      >
        Privacy
      </p>
      <p
        class="u-marginBottom-8 text-caption color-grey-300"
        i18n="@@groupPrivateSegmentsDrawer.privacyDescription"
      >
        Customize how members can use private segments. All admins can view and
        edit private segments by default.
      </p>
      <div class="u-marginBottom-8" [formGroup]="privacySettingsFormGroup">
        <mat-slide-toggle
          labelPosition="before"
          [formControl]="viewableBySelfControl"
          class="u-marginBottom-8 u-width-100 mat-slide-toggle-label--before"
          i18n="@@groupPrivateSegmentsDrawer.visibleToSelfToggle"
        >
          Visible to profile owner
        </mat-slide-toggle>
        <div class="u-paddingLeft-16">
          <mat-slide-toggle
            labelPosition="before"
            [formControl]="showInOnboardingControl"
            class="u-marginBottom-8 u-width-100 mat-slide-toggle-label--before"
            i18n="@@global.showInOnboarding"
          >
            Show in onboarding
          </mat-slide-toggle>
          <mat-slide-toggle
            labelPosition="before"
            [formControl]="editableBySelfControl"
            class="u-marginBottom-8 u-width-100 mat-slide-toggle-label--before"
            i18n="@@global.editableByProfileOwner"
          >
            Editable by profile owner
          </mat-slide-toggle>
        </div>
      </div>
      <p
        class="u-marginBottom-8 u-marginTop-24 text-subtitle-2"
        i18n="@@groupPrivateSegmentsDrawer.interactionSettings"
      >
        Default interactions
      </p>
      <app-group-default-interaction-rules
        [formControl]="defaultInteractionsControl"
        [selectionType]="privateSegment?.selection_type"
        [introductionGoalsSelected]="
          privateSegment?.is_selectable_for_user_introduction_goals
        "
        [isEditing]="!!privateSegment?._id"
        class="u-display-block"
      ></app-group-default-interaction-rules>
    </form>
  </div>
  <div
    class="u-padding-8-0 u-padding-0-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayoutAlign="end center"
    fxLayoutGap="16px"
  >
    <button mat-button (click)="closeDrawer()" i18n="@@global.cancel">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="!privateSegmentForm.valid || this.isLoading"
      (click)="submitForm()"
      i18n="@@global.save"
    >
      Save
    </button>
  </div>
</div>
<mat-progress-bar
  *ngIf="isLoading"
  [ngStyle]="{ bottom: '0', left: '0', right: '0', position: 'absolute' }"
  mode="indeterminate"
  [@fadeInGrowEnter]
  [@fadeOutLeave]
>
</mat-progress-bar>
